import fs from 'node:fs'
import path from 'node:path'
import { formatProjectName } from './format-project-name.js'

export function detectProjectName(cwd: string): string {
  const pkgPath = path.join(cwd, 'package.json')
  if (fs.existsSync(pkgPath)) {
    try {
      const pkg = JSON.parse(fs.readFileSync(pkgPath, 'utf-8'))
      if (typeof pkg.name === 'string' && pkg.name.length > 0) {
        return formatProjectName(pkg.name)
      }
    } catch {}
  }
  return formatProjectName(path.basename(cwd))
}
